import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SubNav from "../../../Shared/SubNav";
import socket from "../../../context/socket";
import { useSearchParams } from "react-router-dom"; // or from 'next/navigation'
import { Tab1 } from "./Tab1";
import { Tab2 } from "./Tab2";
import { Tab3 } from "./Tab3";
import _ from "lodash";

export const PortfolioReviewDetail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [selectedMember, setSelectedMember] = useState([]);
  // console.log("selectedMember",selectedMember);
  const [isPrsuggections, setPrsuggections] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedCards, setSelectedCards] = useState([]);
  // State to keep track of the active tab
  const [isChecked, setIsChecked] = useState(true);
  const [activeTab, setActiveTab] = useState("home-tab");

  const [isViewArchivedEvent, setIsViewArchivedEvent] = useState("");
  const goalEventId = searchParams.get("goalEventId");
  const prId = searchParams.get("prId");
  const isHomeTabEnabled = Boolean(prId);
  const isProfileTabEnabled = Boolean(goalEventId);
  useEffect(() => {
    if (goalEventId) {
      setActiveTab("profile-tab");
    } else if (prId) {
      setActiveTab("home-tab");
    }
  }, [searchParams]);

  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  // Debounced function to emit messages
  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      // console.log("Emiting message :", activeTab, selectedTab, isPrsuggections);
      socket.emit("gateway", {
        room: roomId,
        data: {
          selectedCards,
          activeTab,
          selectedTab,
          isPrsuggections,
          selectedMember,
          isChecked,
        },
      });
    }, 300),
    [
      selectedCards,
      activeTab,
      selectedTab,
      isPrsuggections,
      selectedMember,
      isChecked,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCards,
    debouncedEmitMessage,
    selectedTab,
    isPrsuggections,
    selectedMember,
    isChecked,
  ]);

  const handleNext = () => {
    const nextUrl = "/customized-action-plan?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = "/my-investment?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  // Function to change the active tab
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setSelectedTab(1);
    setIsViewArchivedEvent("");
  };

  useEffect(() => {
    console.log("checking", isViewArchivedEvent);
    if (isViewArchivedEvent) {
      handleTabChange("profile-tab");
    }
  }, [isViewArchivedEvent]);

  return (
    <>
      <div className="container position-relative minht">
        <div className="row mb-3">
          <div className="col">
            <ul
              className="nav nav-tabs justify-content-start mb-3"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${
                    activeTab === "home-tab" ? "active" : ""
                  }`}
                  id="home-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="home-tab-pane"
                  aria-selected={activeTab === "home-tab"}
                  onClick={() =>
                    isHomeTabEnabled && handleTabChange("home-tab")
                  }
                  disabled={!isHomeTabEnabled}
                  style={{
                    cursor: isHomeTabEnabled ? "pointer" : "not-allowed",
                    opacity: isHomeTabEnabled ? 1 : 0.6,
                  }}
                >
                  <span
                    className={`fs-21 mt-3 ${
                      activeTab !== "home-tab" && "clrgreen-black"
                    }`}
                  >
                    Portfolio Review
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${
                    activeTab === "profile-tab" ? "active" : ""
                  }`}
                  id="profile-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="profile-tab-pane"
                  aria-selected={activeTab === "profile-tab"}
                  onClick={() =>
                    isProfileTabEnabled && handleTabChange("profile-tab")
                  }
                  disabled={!isProfileTabEnabled}
                  style={{
                    cursor: isProfileTabEnabled ? "pointer" : "not-allowed",
                    opacity: isProfileTabEnabled ? 1 : 0.6,
                  }}
                >
                  <span
                    className={`fs-21 mt-3 ${
                      activeTab !== "profile-tab" && "clrgreen-black"
                    }`}
                  >
                    Goal Event
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link border-0 navclr ${
                    activeTab === "Event-tab" ? "active" : ""
                  }`}
                  id="Event-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="Event-tab-pane"
                  aria-selected={activeTab === "Event-tab"}
                  onClick={() => {
                    handleTabChange("Event-tab");
                  }}
                >
                  <span
                    className={`fs-21 mt-3 ${
                      activeTab !== "Event-tab" && "clrgreen-black"
                    }`}
                  >
                    Event History
                  </span>
                </button>
              </li>
            </ul>

            {/* Conditionally render tab content */}
            {activeTab === "home-tab" && (
              <Tab1
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                setSelectedCards={setSelectedCards}
                selectedCards={selectedCards}
                setPrsuggections={setPrsuggections}
                isPrsuggections={isPrsuggections}
                setSelectedMember={setSelectedMember}
                selectedMember={selectedMember}
                setIsChecked={setIsChecked}
                isChecked={isChecked}
              />
            )}
            {activeTab === "profile-tab" && (
              <Tab2 roomId={roomId} isViewArchivedEvent={isViewArchivedEvent} />
            )}
            {activeTab === "Event-tab" && (
              <Tab3 setIsViewArchivedEvent={setIsViewArchivedEvent} handleTabChange={handleTabChange} />
            )}
            {/* {activeTab === "ei-tab" && (
              <Tab4
                roomId={roomId}
                isViewArchivedEvent={isViewArchivedEvent}
                setSelectedTab={setSelectedTab}
                selectedTab={selectedTab} 
              />
            )} */}
          </div>
        </div>
      </div>

      {/* <div className="row mt-md-3 mt-4">
        <div className="col">
          <div className="container">
            <div className="row my-4">
              <div className="col text-end">
                <a href="javascript:void(0);" onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};
